import type { Resource } from "i18next";

import enBenchmark from "~/locales/en/benchmark.json" with { type: "json" };
import enCommon from "~/locales/en/common.json" with { type: "json" };
import enForecast from "~/locales/en/forecast.json" with { type: "json" };
import enFulfill from "~/locales/en/fulfill.json" with { type: "json" };
import enMobile from "~/locales/en/mobile.json" with { type: "json" };
import enPortal from "~/locales/en/portal.json" with { type: "json" };
import enProduce from "~/locales/en/produce.json" with { type: "json" };
import enRestock from "~/locales/en/restock.json" with { type: "json" };
import esBenchmark from "~/locales/es/benchmark.json" with { type: "json" };
import esCommon from "~/locales/es/common.json" with { type: "json" };
import esForecast from "~/locales/es/forecast.json" with { type: "json" };
import esFulfill from "~/locales/es/fulfill.json" with { type: "json" };
import esMobile from "~/locales/es/mobile.json" with { type: "json" };
import esPortal from "~/locales/es/portal.json" with { type: "json" };
import esProduce from "~/locales/es/produce.json" with { type: "json" };
import esRestock from "~/locales/es/restock.json" with { type: "json" };

const resources: Resource = {
	en: {
		benchmark: enBenchmark,
		common: enCommon,
		mobile: enMobile,
		fulfill: enFulfill,
		produce: enProduce,
		forecast: enForecast,
		portal: enPortal,
		restock: enRestock
	},
	es: {
		benchmark: esBenchmark,
		common: esCommon,
		mobile: esMobile,
		fulfill: esFulfill,
		produce: esProduce,
		forecast: esForecast,
		portal: esPortal,
		restock: esRestock
	}
};

export default resources;
